export default __webpack_public_path__ + "static/char-43-anr-7ce9000717ff36a86ff25d2d0e24b9f5.webp";